import apiClient from '@/api/client'

export interface AttachmentResponse {
  id: string
  filename: string
  original_filename?: string
  content_type: string
  file_size?: number
  created_at?: string
}

export const attachmentsApi = {
  async upload(file: File): Promise<AttachmentResponse> {
    const form = new FormData()
    form.append('file', file)
    const { data } = await apiClient.post('/api/v1/attachments/upload', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return data
  },
  async get(id: string): Promise<AttachmentResponse> {
    const { data } = await apiClient.get(`/api/v1/attachments/${id}`)
    return data
  },
  /** Fetch with the auth header, then hand the bytes to the browser as a file download. */
  async download(id: string, filename: string): Promise<void> {
    const { data } = await apiClient.get(`/api/v1/attachments/${id}/download`, { responseType: 'blob' })
    const url = URL.createObjectURL(data as Blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    a.remove()
    setTimeout(() => URL.revokeObjectURL(url), 1000)
  },
}
